/* "You may also like" add-ons for the cart popup and cart page.
   Product list comes from snippets/zg-addons.liquid. */
(function () {
  var PACK = 70000, FREE = 100000;
  var dataEl = document.getElementById('zg-addons-data');
  if (!dataEl) return;
  var ALL = [];
  try { ALL = JSON.parse(dataEl.textContent) || []; } catch (e) { return; }
  if (!ALL.length) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var onCartPage = /\/cart\/?$/.test(location.pathname);
  var lastSig = '';

  function rand(c) {
    return 'R' + Math.round(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function pick(cart, max) {
    var inCart = {};
    (cart.items || []).forEach(function (i) { inCart[i.product_id] = true; });
    var c = ALL.filter(function (p) { return !inCart[p.p]; });
    var total = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    var target = total < PACK ? PACK : total < FREE ? FREE : 0;
    var gap = target ? target - total : 0;
    var byPrice = c.slice().sort(function (a, b) { return a.price - b.price; });
    var out = [];
    if (gap) {
      byPrice.forEach(function (p) { if (p.price >= gap && out.length < 2) out.push(p); });
    }
    byPrice.forEach(function (p) { if (out.length < max && out.indexOf(p) < 0) out.push(p); });
    out.sort(function (a, b) { return a.price - b.price; });
    return out.map(function (p) {
      var tag = '';
      if (gap && p.price >= gap) tag = target === FREE ? 'Unlocks free shipping' : 'Unlocks signature packaging';
      return { p: p, tag: tag };
    });
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  var CSS = '.zg-addons{margin:1.6rem 0 0}' +
    '.zg-addons__h{font-size:1.5rem;margin:0 0 .8rem;font-weight:600}' +
    '.zg-addons__list{display:flex;gap:1rem;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;list-style:none;margin:0;padding:0 0 .6rem}' +
    '.zg-addons__list::-webkit-scrollbar{height:4px}.zg-addons__list::-webkit-scrollbar-thumb{background:#E8D08A;border-radius:4px}' +
    '.zg-addon{flex:0 0 13.5rem;scroll-snap-align:start;display:flex;flex-direction:column;gap:.4rem;border:1px solid #F2E5E5;border-radius:1.4rem;padding:1rem;background:#fff;text-align:left}' +
    '.zg-addon img{width:100%;height:8rem;object-fit:contain;background:#fff}' +
    '.zg-addon__t{font-size:1.25rem;line-height:1.3;color:inherit;text-decoration:none;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:3.25rem}' +
    '.zg-addon__p{font-weight:600;font-size:1.3rem}' +
    '.zg-addon__tag{font-size:1.1rem;color:#B8923A;line-height:1.2}' +
    '.zg-addon__btn{margin-top:auto;min-height:3.6rem;border-radius:999px;border:1px solid #9E5562;background:#fff;color:#9E5562;font:inherit;font-size:1.3rem;font-weight:600;cursor:pointer}';
  if (!document.getElementById('zg-addons-css')) {
    var st = document.createElement('style'); st.id = 'zg-addons-css'; st.textContent = CSS; document.head.appendChild(st);
  }

  function html(list) {
    if (!list.length) return '';
    return '<h3 class="zg-addons__h">You may also like <span style="font-weight:400;opacity:.7">→ swipe</span></h3><ul class="zg-addons__list" role="list">' +
      list.map(function (x) {
        var p = x.p;
        return '<li class="zg-addon">' +
          (p.img ? '<img src="' + esc(String(p.img).replace(/width=\d+/, 'width=240')) + '" alt="" width="120" height="80" loading="lazy">' : '') +
          '<a class="zg-addon__t" href="' + esc(p.u) + '">' + esc(p.t) + '</a>' +
          '<span class="zg-addon__p">' + rand(p.price) + '</span>' +
          (x.tag ? '<span class="zg-addon__tag">' + x.tag + '</span>' : '') +
          '<button type="button" class="zg-addon__btn" data-zg-add="' + p.v + '" aria-label="Add ' + esc(p.t) + ' to cart">Add</button>' +
          '</li>';
      }).join('') + '</ul>';
  }

  function spots() {
    var s = [];
    var note = document.querySelector('.cart-notification__links');
    if (note) s.push({ parent: note, after: null, max: 6 });
    document.querySelectorAll('#main-cart-footer .cart__ctas').forEach(function (c) { s.push({ parent: c.parentNode, after: c, max: 6 }); });
    return s;
  }

  /* Suggestions sit BELOW the checkout button so it stays in view on phones */
  function render(cart) {
    spots().forEach(function (s) {
      var box = s.parent.querySelector(':scope > .zg-addons');
      if (!cart.item_count) { if (box) box.remove(); return; }
      if (!box) {
        box = document.createElement('div');
        box.className = 'zg-addons';
      }
      if (s.after) {
        if (s.after.nextElementSibling !== box) s.after.insertAdjacentElement('afterend', box);
      } else if (s.parent.lastElementChild !== box) {
        s.parent.appendChild(box);
      }
      box.innerHTML = html(pick(cart, s.max));
    });
  }

  var t;
  function check(force) {
    clearTimeout(t);
    t = setTimeout(function () {
      fetch(root + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var sig = cart.item_count + ':' + cart.items_subtotal_price + ':' + (cart.items || []).map(function (i) { return i.product_id; }).join(',');
          var missing = spots().some(function (s) { return cart.item_count && !s.parent.querySelector(':scope > .zg-addons'); });
          if (force || sig !== lastSig || missing) { lastSig = sig; render(cart); }
        })
        .catch(function () {});
    }, 300);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-zg-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-zg-add')), quantity: 1 }], sections: 'cart-icon-bubble,cart-notification-button' })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        if (onCartPage) { location.reload(); return; }
        btn.textContent = 'Added';
        ['cart-icon-bubble', 'cart-notification-button'].forEach(function (id) {
          var el = document.getElementById(id);
          if (!el || !res.sections || !res.sections[id]) return;
          var doc = new DOMParser().parseFromString(res.sections[id], 'text/html');
          var inner = doc.querySelector('.shopify-section');
          if (inner) el.innerHTML = inner.innerHTML;
        });
        setTimeout(function () { check(true); }, 600);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Try again';
      });
  });

  new MutationObserver(function (list) {
    var hit = list.some(function (m) {
      var el = m.target.nodeType === 1 ? m.target : m.target.parentNode;
      if (!el || !el.closest || el.closest('.zg-addons')) return false;
      return !!el.closest('#main-cart-items, #main-cart-footer, cart-items, #cart-notification, #cart-icon-bubble');
    });
    if (hit) check(false);
  }).observe(document.body, { childList: true, subtree: true });
  check(true);
})();
